/**
 * Client "On Hold" business rules
 *
 * When a client has status "On Hold":
 * - Cannot create new projects for that client.
 * - Cannot create new work items for projects under that client.
 * - Cannot delete client if active projects exist.
 * - Monthly Budget Usage = Total billable hours in the selected month.
 * - Changing monthly limit does not affect locked months.
 */

export const CLIENT_STATUS_ON_HOLD = "On Hold";

/** Project statuses that block client delete: if any project of the client is in these statuses (e.g. In Progress), the client cannot be deleted */
export const ACTIVE_PROJECT_STATUSES = [
  "In-Progress",
  "In Progress",
  "Active",
  "Paused",
  "On Hold",
  "Draft",
];

export function isClientOnHold(client) {
  if (!client) return false;
  const status = client.status?.trim() || "";
  return status.toLowerCase() === "on hold";
}

/** Returns true if the client can have new projects created (not On Hold) */
export function canCreateProjectsForClient(client) {
  return !isClientOnHold(client);
}

/** Returns true if the client can be deleted (no projects in In Progress or other active status) */
export function canDeleteClient(client, projectsList = []) {
  if (!client?.clientName) return true;
  const activeCount = (projectsList || []).filter(
    (p) => p.clientName === client.clientName && ACTIVE_PROJECT_STATUSES.includes(p.status)
  ).length;
  return activeCount === 0;
}

/** Get count of active projects for a client */
export function getActiveProjectsCountForClient(clientName, projectsList = []) {
  if (!clientName || !Array.isArray(projectsList)) return 0;
  return projectsList.filter(
    (p) => p.clientName === clientName && ACTIVE_PROJECT_STATUSES.includes(p.status)
  ).length;
}
